
import { ApiHelper } from './helper/ApiHelper';

const apiHelper = new ApiHelper();

export class AESService {
    constructor() {
    }    
    EncodeUsingAES(value) {
        var CryptoJS = require("crypto-js");
        if (value === undefined || value === null) {
          return "";
        } else {
          const keys = atob(process.env.VUE_APP_E_K)
          const key = CryptoJS.enc.Utf8.parse(keys);
          const vectorIV = CryptoJS.enc.Utf8.parse(keys);
          const encrypted = CryptoJS.AES.encrypt(
            CryptoJS.enc.Utf8.parse(value.toString()),
            key,
            {
              keySize: 128 / 8,
              iv: vectorIV,
              mode: CryptoJS.mode.CBC,
              padding: CryptoJS.pad.Pkcs7
            }
          );
          return encrypted.toString();
        }
      }
}